import type { VoidComponent } from "solid-js";
import { useTranslation } from "../../../state/i18n.tsx";
import Text from "../../../components/text/Text.tsx";
import { CloseTrigger } from "../../../components/drawer/Drawer.tsx";
import { IconButton } from "../../../components/button/Button.tsx";

const VersionHistoryHeader: VoidComponent = () => {
  const { t } = useTranslation();

  return (
    <div class="flex w-full items-center justify-between border-b border-subtle bg-surface-default py-3 pr-4 pl-6">
      <Text class="text-medium-semibold" as="h2" text={t(($) => $.VERSION_HISTORY_DRAWER_TITLE)} />
      <CloseTrigger
        asChild={(parentProps) => (
          <IconButton
            {...parentProps}
            icon="x"
            aria-label={t(($) => $.VERSION_HISTORY_DRAWER_CLOSE)}
            variant="tertiary"
          />
        )}
      />
    </div>
  );
};

export default VersionHistoryHeader;
